
import Vue from 'vue'
export default Vue.extend({
  name: 'SteelspaceLogoSvg',
  props: {
    color: {
      default: 'currentColor',
      type: String,
    },
  },
})
